module.exports = {
      id: "tv-usage",
      viewBox: "0 0 24.014 24",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#tv",
      toString: function () {
        return this.url;
      }
    }